import { ActivatedRoute, ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { CamerallaAuthService } from '../authentication-services/cameralla-auth.service';
import { UserService } from '../../../modules/user/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { GlobalVariables } from '../../models/cameralla-global.model';
import { MemberTagConstant } from "../../constants/member-tag.constant";
import AppShareHelper from "../../utils/helper";

@Injectable({
    providedIn: 'root'
})
export class PersmissionGuardService implements CanActivate {
    constructor(private userService: UserService,
                private authService: CamerallaAuthService,
                private router: Router,
                private route: ActivatedRoute,
                private toastr: ToastrService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const userId = +this.authService.getLocalUserInfo()['id'];
        
        if (state.url == '/member-feeds') {
            return this.userService.getPersonalDetails(userId).then(
              (resolve: any) => {
                return AppShareHelper.checkVipMember(resolve.accessLevel);
              }
            );
        } else {
            const partnerPointing = route.params['partner'].toString();
            
            if (partnerPointing.length > 0) {
                const partner = GlobalVariables.partnerNavigators.filter(obj => {
                    return obj.value === partnerPointing;
                });
        
                if (partner.length) {
                    return this.userService.getUserInformation(userId).then(
                      (resolve: any[]) => {
                          const userProfile = Object.assign(resolve[0], resolve[1]);
                          userProfile.allowAccess = userProfile.kartraTags.includes(partner[0]);
                  
                          if (!userProfile.allowAccess) {
                              this.backToHome();
                          }
                  
                          return userProfile.allowAccess;
                      }
                    );
                } else {
                    this.backToHome();
                }
            } else {
                return true;
            }
        }
    }

    backToHome() {
        this.toastr.error('Page not found or you are not authorized to access.', 'WARNING');
        this.router.navigate(['/']);
    }
}
